import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "@/features/profile/ProfilePage";
import { loadPublic } from "@/lib/guards";

export const Route = createFileRoute("/u/$username")({
  beforeLoad: loadPublic,
  component: ProfilePage,
});
